import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import axios from "axios";
import { useAuth } from "./AuthContext";
import { getOrgShortName } from "../config";

export function NavBar() {
  const { setIsAuthenticated, authToken, setAuthToken } = useAuth();
  const [navItems, setNavItems] = useState([]);
  
  useEffect(() => {
    const loadNavbar = async () => {
      try {
        const token = localStorage.getItem("auth_token") || authToken;
        const headers = token ? { Authorization: `Bearer ${token}` } : {};
        const res = await axios.get("/api/member-navbar", { headers });
        setNavItems(res.data);
      } catch (error) {
        console.error("Error loading member navbar:", error);
        setNavItems([]);
      }
    };
    
    loadNavbar();
  }, [authToken]);

  const location = useLocation();
  const isPeopleActive = () =>
    location.pathname.startsWith("/members/directory") ||
    location.pathname.startsWith("/members/executive-board") ||
    location.pathname.startsWith("/members/committees");

  const isActive = (path) =>
    location.pathname === path;

  const isPathIn = (paths = []) =>
    paths.some(p => location.pathname.startsWith(p));

  const handleLogout = () => {
    localStorage.removeItem("auth_token");
    setAuthToken(null);
    setIsAuthenticated(false);
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light shadow-sm sticky-top">
      <div className="container">
        {/* Navbar toggler for mobile */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarTogglerDemo03"
          aria-controls="navbarTogglerDemo03"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Brand */}
        <Link to="/members" className="navbar-brand">
          {getOrgShortName()} Member Portal
        </Link>

        {/* Nav items + Back to site */}
        <div className="collapse navbar-collapse w-100" id="navbarTogglerDemo03">
          <div className="d-flex flex-column flex-lg-row justify-content-between w-100 gap-2">
            {/* Main nav links */}
            <ul className="navbar-nav d-flex flex-column flex-lg-row gap-2 mb-0">
              <li className="nav-item">
                <Link
                  to="/members/home"
                  className={`nav-link ${isActive("/members/home") ? "active fw-bold" : ""}`}
                >
                  Home
                </Link>
              </li>
              <li className="nav-item dropdown">
                <Link
                  className={`nav-link dropdown-toggle ${isPeopleActive() ? "active fw-bold" : ""}`}
                >
                  People
                </Link>

                <ul className="dropdown-menu show">
                  <li>
                    <Link to="/members/directory" className="dropdown-item">
                      Directory
                    </Link>
                  </li>
                  <li>
                    <Link to="/members/executive-board" className="dropdown-item">
                      Executive Board
                    </Link>
                  </li>
                  <li>
                    <Link to="/members/committees" className="dropdown-item">
                      Committees
                    </Link>
                  </li>
                </ul>

              </li>

              <li className="nav-item">
                <Link
                  to="/members/events"
                  className={`nav-link ${isActive("/members/events") ? "active fw-bold" : ""}`}
                >
                  Events
                </Link>
              </li>

              {/* Start dynamic nav links */}
              {navItems.map((item, idx) => {
                const hasChildren = item.children && item.children.length > 0;
                const topLevelPath = `/members/${item.slug || ""}`;
                const childPaths = item.children?.map(c => `/members/${c.slug}`) || [];
                const isDropdownActive =
                  location.pathname === topLevelPath || isPathIn(childPaths);

                return (
                  <li
                    className={`nav-item${hasChildren ? " dropdown" : ""}`}
                    key={idx}
                  >
                    <Link
                      {...(item.slug ? { to: topLevelPath } : {})}
                      className={`nav-link${hasChildren ? " dropdown-toggle" : ""} ${isDropdownActive ? "active fw-bold" : ""}`}
                      {...(hasChildren && {
                        id: `dropdown-${idx}`
                      })}
                    >
                      {item.label}
                    </Link>

                    {hasChildren && (
                      <ul className="dropdown-menu" aria-labelledby={`dropdown-${idx}`}>
                        {item.children.map((c, j) => (
                          <li key={j}>
                            <Link
                              {...(c.slug ? { to: `/members/${c.slug}` } : {})}
                              className={`dropdown-item ${location.pathname === `/members/${c.slug}` ? "active fw-bold" : ""}`}
                            >
                              {c.label}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                );
              })}

              <li className="nav-item">
                <Link
                  to="/members/account"
                  className={`nav-link ${isActive("/members/account") ? "active fw-bold" : ""}`}
                >
                  My Account
                </Link>
              </li>

            </ul>

            {/* Right-aligned Back to site link */}
            <div>
              <Link
                to="/"
                className="btn btn-custom-outline btn-sm"
              >
                Back to site
              </Link>
              <a
                className="btn btn-dark btn-sm mx-2"
                onClick={handleLogout}
                href="/members"
              >
                Logout
              </a>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}
